import { createSelector } from 'reselect';

import endOfDay from 'date-fns/endOfDay';
import startOfDay from 'date-fns/startOfDay';

import { RootState, VirtualCardOperation } from '../types';

export const selectOperationsRoot = createSelector(
  (state: RootState) => state.virtualCard.operations,
  (state) => state
);

const selectById = createSelector(selectOperationsRoot, (operationsRoot) => operationsRoot.byId);

const selectStartDate = createSelector(selectOperationsRoot, (operationsRoot) =>
  operationsRoot.startDate ? new Date(operationsRoot.startDate) : null
);
const selectStartOfStartDate = createSelector(selectStartDate, (startDate) => {
  if (!startDate) {
    return null;
  }

  return startOfDay(startDate);
});
const selectEndDate = createSelector(selectOperationsRoot, (operationsRoot) =>
  operationsRoot.endDate ? new Date(operationsRoot.endDate) : null
);
const selectEndOfEndDate = createSelector(selectEndDate, (endDate) => {
  if (!endDate) {
    return null;
  }

  return endOfDay(endDate);
});
const selectPageSize = createSelector(
  selectOperationsRoot,
  (operationsRoot) => operationsRoot.pageSize
);
const selectPageNumber = createSelector(
  selectOperationsRoot,
  (operationsRoot) => operationsRoot.pageNumber
);

export const selectOperationsStatus = createSelector(selectOperationsRoot, (state) => state.status);

export const selectOperationsPageNumber = createSelector(
  selectOperationsRoot,
  (state) => state.pageNumber
);

export const selectOperationsTotal = createSelector(selectOperationsRoot, (state) => state.total);

export const selectOperations = createSelector(
  selectById,
  selectStartOfStartDate,
  selectEndOfEndDate,
  selectPageSize,
  selectPageNumber,
  (operationsById, startDate, endDate, pageSize, pageNumber) => {
    if (!startDate || !endDate) {
      return [];
    }

    if (!pageNumber || !pageSize) {
      return [];
    }

    if (!operationsById) {
      return [];
    }

    const operations: VirtualCardOperation[] = Object.values(operationsById)
      .map(({ date, ...rest }) => ({ ...rest, date: new Date(date) }))
      .filter((operation) => operation.date >= startDate && operation.date <= endDate)
      .sort((o1, o2) => o2.date.getTime() - o1.date.getTime());

    operations.splice(pageNumber * pageSize);

    return operations;
  }
);
